const logLevelString =
  process.env.REACT_APP_LOG_LEVEL || (process.env.NODE_ENV === 'production' && 'ERROR') || 'DEBUG';

const Level = {
  DEBUG: {
    level: 0,
    log: console.debug.bind(window.console),
  },
  INFO: {
    level: 1,
    log: console.log.bind(window.console),
  },
  WARN: {
    level: 2,
    log: console.warn.bind(window.console),
  },
  ERROR: {
    level: 3,
    log: console.error.bind(window.console),
  },
};

const logLevel = Level[logLevelString] || Level.DEBUG;

const makeLogger = level => (level.level >= logLevel.level ? level.log : () => {});

export default {
  debug: makeLogger(Level.DEBUG),
  info: makeLogger(Level.INFO),
  warn: makeLogger(Level.WARN),
  error: makeLogger(Level.ERROR),
};



// WEBPACK FOOTER //
// ./src/util/log.js